module.exports = {
	"Aggressive Allocation": 20,
	"China Region": 1,
	"Commodities Focused": 1,
	"Communications": 25,
	"Consumer Cyclical": 39,
	"Consumer Defensive": 15,
	"Diversified Emerging Mkts": 6,
	"Diversified Pacific/Asia": 6,
	"Energy Limited Partnership": 27,
	"Equity Energy": 51,
	"Equity Precious Metals": 29,
	"Europe Stock": 36,
	"Financial": 51,
	"Foreign Large Blend": 275,
	"Foreign Large Growth": 121,
	"Foreign Large Value": 140,
	"Foreign Small/Mid Blend": 27,
	"Foreign Small/Mid Growth": 38,
	"Foreign Small/Mid Value": 27,
	"Global Aggressive Allocation": 25,
	"Global Large-Stock Blend": 134,
	"Global Large-Stock Growth": 97,
	"Global Large-Stock Value": 61,
	"Global Moderate Allocation": 71,
	"Global Moderately Aggressive Allocation": 41,
	"Global Moderately Conservative Allocation": 1,
	"Global Real Estate": 52,
	"Global Small/Mid Stock": 62,
	"Health": 88,
	"Industrials": 46,
	"Infrastructure": 43,
	"Japan Stock": 23,
	"Large Blend": 613,
	"Large Growth": 402,
	"Large Value": 439,
	"Mid-Cap Blend": 205,
	"Mid-Cap Growth": 169,
	"Mid-Cap Value": 169,
	"Miscellaneous Allocation": 2,
	"Miscellaneous Region": 43,
	"Miscellaneous Sector": 30,
	"Moderate Allocation": 100,
	"Moderately Aggressive Allocation": 34,
	"Natural Resources": 74,
	"Pacific/Asia ex-Japan Stk": 5,
	"Real Estate": 92,
	"Small Blend": 246,
	"Small Growth": 154,
	"Small Value": 165,
	"Tactical Allocation": 25,
	"Target-Date 2025": 4,
	"Target-Date 2030": 33,
	"Target-Date 2035": 41,
	"Target-Date 2040": 42,
	"Target-Date 2045": 43,
	"Target-Date 2050": 44,
	"Target-Date 2055": 44,
	"Target-Date 2060": 44,
	"Target-Date 2065+": 59,
	"Technology": 169,
	"Utilities": 26
};


//////////////////
// WEBPACK FOOTER
// ./src/data/GefScoreNormalizersPeers.json
// module id = 934
// module chunks = 0